import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './payment-page.css';
import CustomTextField from 'components/mui/text-field';
import { Button, MenuItem } from '@mui/material';
import { GetPaymentLink } from './logic/PaymentLogic';

const PaymentPage = () => {
  
  const [selectedMethod, setSelectedMethod] = useState(0);
  const [amount, setAmount] = useState(0);
  const [currentDate, setCurrentDate] = useState('');  
  const [token, setToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [invoiceId, setInvoiceId] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([])

  useEffect(() => {
    // Get invoice ID from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('invoice_id');
    const Amount = urlParams.get('amount');
    const Token = urlParams.get('token');
    const PaymentMethods = urlParams.get('payment_methods');
    let paymentMethodsArray = [];
    
    if (PaymentMethods && PaymentMethods.trim() !== "") {
      paymentMethodsArray = PaymentMethods.split(",").map(method => method.trim());
    } else {     
      paymentMethodsArray = ["Card", "ACH", "BankTransfer", "ApplePay", "GooglePay"];
    }

    if (id) {
      setInvoiceId(id);
      setAmount(Number(Amount || 0) || 0);
      setToken(Token || '');
      setPaymentMethods(paymentMethodsArray);
    }

    // Set current date
    setCurrentDate(new Date().toLocaleDateString());

    // Fetch available payment methods
    //fetchPaymentMethods();
  }, []);
   

  const handlePayment = async () => {
    if (!selectedMethod) {
      setError('Please select a payment method');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      
      const payload = {
        token,
        invoiceId,
        paymentMethod: selectedMethod,
        notes: 'Payment for invoice ' + invoiceId,
        PaidBy: 'Customer'
      }

      const paymentLogResponse = await GetPaymentLink(payload);
      
      if (!paymentLogResponse.isError) {
        window.location.href = paymentLogResponse.result.url;
      } else {
        setError(paymentLogResponse.message);
      }

    } catch (err) {
      setError('Payment error:', err);
      console.error('Payment error:', err);
    } finally {
      setIsLoading(false);
    }
  };


  const dropdownOptions = [
    { label: "Card", value: "Card" },
    { label: "ACH", value: "ACH" },
    { label: "Bank Transfer", value: "BankTransfer" },
    { label: "Apple Pay", value: "ApplePay" },
    { label: "Google Pay", value: "GooglePay" },
  ];

  const filteredOptions = dropdownOptions.filter(opt => paymentMethods.includes(opt.value));


  return (
    <div className="payment-container">
      <div className="payment-card">
       <h3 style={{ textAlign: 'center' }}>Complete Your Payment</h3>
        
        {error && <div className="error-message">{error}</div>}
        
        <div className="payment-details">
          <div className="detail-row">
            <span className="label">Invoice ID:</span>
            <span className="value">INV-{invoiceId}</span>
          </div>
          
          <div className="detail-row">
            <span className="label">Amount:</span>
            <span className="value amount">${amount.toFixed(2)}</span>
          </div>
          
          <div className="detail-row">
            <span className="label">Date:</span>
            <span className="value">{currentDate}</span>
          </div>
        </div>

        <div className="payment-method">          
          <CustomTextField
              fullWidth
              select
              label="Payment Method"
              value={selectedMethod}            
              onChange={e => {
                setSelectedMethod(e.target.value);
                //setErrors(prev => ({ ...prev, paymentMethod: undefined }));
              }}
              //error={Boolean(errors.paymentMethod)}
              //helperText={errors.paymentMethod}
            >        
             <MenuItem value={0}>Select a method</MenuItem>      
             {filteredOptions.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
              ))}
            </CustomTextField>
        </div>

        <Button
          onClick={handlePayment}
          variant="contained"
          color={"main"}          
          disabled={isLoading || !selectedMethod || amount === 0}
          className="pay-now-btn"
        >
          {isLoading ? 'Processing...' : 'Pay Now'}
        </Button>

        <div className="security-note">
          <p>🔒 Your payment is secure and encrypted</p>
          <p>Powered by Stripe</p>
        </div>
      </div>
    </div>
  );
};


export default PaymentPage;